import { Typography } from '@material-ui/core'
import React from 'react'
import { DateTime } from '@flatsy/utils/dates'
import i18n from '@flatsy/utils/translations'
import { componentsProps } from './Type'
import useStyles from './Style'

const HightlightSlot: React.FC<componentsProps> = ({
  handleClickOnSlot,
  hightlightSlot,
}): React.ReactElement => {
  const classes = useStyles()
  const event = () => {
    handleClickOnSlot(hightlightSlot.fullDate)
  }

  return (
    <button type="button" className={classes.slot} onClick={event}>
      <Typography className={classes.slotInner}>
        {i18n.t('@date_at', { value: DateTime.fromISO(hightlightSlot.fullDate) })}
      </Typography>
    </button>
  )
}

export default HightlightSlot
